import React from 'react';
import {twMerge} from 'tailwind-merge';

import {SettingLabel} from '../WorkspaceDrawer/Settings/components/SettingLabel';

export const WorkspaceTemplateRow = ({
  description,
  label,
}: {
  description?: string;
  label: string;
}) => {
  return (
    <div className={twMerge('flex flex-col')}>
      <SettingLabel text={label} className={twMerge('w-fit')} />
      {description && (
        <h4
          className={twMerge(
            'font-[inherit] text-sm leading-[140%] text-wb-text-tertiary',
            'mr-16'
          )}>
          {description}
        </h4>
      )}
    </div>
  );
};
